/* global I18n */

import React from "react"
import FaIcon from "components/fa_icon"
import {use_configuration} from "./configuration_provider"

function QuizModeCard({
  image_path,
  quiz_mode,
  is_selected
}) {
  const {update_configuration} = use_configuration()

  return (
    <>
      <div className={`container ${is_selected ? "selected" : ""}`}
           onClick={() =>
             update_configuration({quiz_mode, exam_conditions: false})
          }
      >
        <div className={`icon-container ${is_selected ? "show" : ""}`}>
          <FaIcon name={"fa-check"}/>
        </div>
        <div className="image">
          <img src={image_path} width="72" height="90" alt=""/>
        </div>
        <div className="content">
          <h3 className="title">
            {I18n.t(`js.quiz_mode_selector.${quiz_mode}`)}
          </h3>
          <p className="description">
            {I18n.t(`js.quiz_mode_selector.${quiz_mode}_description`)}
          </p>
          <p className="hint">
            {I18n.t(`js.quiz_mode_selector.${quiz_mode}_helper`)}
          </p>
        </div>
      </div>
      <div className={`switcher ${is_selected ? "selected" : ""}`}
           onClick={() => update_configuration({quiz_mode})}>
        <FaIcon name={"fa-retweet"} text_aligned={true}/>
        {I18n.t(`js.quiz_mode_selector.switch_to_${quiz_mode}`)}
      </div>
    </>
  )
}

export default QuizModeCard
